import { currentRuntime } from './config/runtime';

type SnapTradeCallbackWindow = Window & typeof globalThis;

export function maybeHandleSnapTradeCallback(win: SnapTradeCallbackWindow = window, doc: Document = document): boolean {
  if (win.location.pathname !== '/snaptrade/callback') {
    return false;
  }

  const brandName = currentRuntime.brand.displayName || 'your workspace';
  const params = new URLSearchParams(win.location.search || '');
  const requestedReturnTo = params.get('returnTo') || '/settings';
  const returnTo = requestedReturnTo.startsWith('/') && !requestedReturnTo.startsWith('//') ? requestedReturnTo : '/settings';

  const root = doc.getElementById('root');
  if (root) {
    root.innerHTML = `
      <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;background:#0b1220;color:#e2e8f0;font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;padding:24px;">
        <div style="max-width:460px;width:100%;background:rgba(15,23,42,0.92);border:1px solid rgba(148,163,184,0.18);border-radius:16px;padding:24px;text-align:center;box-shadow:0 20px 40px rgba(2,6,23,0.35);">
          <div style="font-size:18px;font-weight:600;">Broker connection complete</div>
          <div style="margin-top:10px;font-size:14px;color:#94a3b8;line-height:1.5;">Returning you to ${brandName}. You can close this window if it stays open.</div>
        </div>
      </div>
    `;
  }

  try {
    win.localStorage.setItem(
      'tt_snaptrade_callback',
      JSON.stringify({
        ts: Date.now(),
        query: win.location.search,
        returnTo,
      }),
    );
  } catch {}

  try {
    win.opener?.postMessage(
      {
        type: 'tt:snaptrade:callback',
        query: win.location.search,
        returnTo,
      },
      win.location.origin,
    );
  } catch {}

  try {
    win.opener?.focus?.();
  } catch {}

  win.setTimeout(() => {
    try {
      if (win.opener) {
        win.close();
      } else {
        win.location.href = returnTo;
      }
    } catch {}
  }, 50);

  return true;
}
